import { Box, Button, ButtonList, StyledHtml, Text } from "@postenbring/hedwig-react"


export const CTABox = ({ title, text, buttons }) => (
    <Box variant="white" className="hds-mb-20-24">
        <Text variant="h2" as="h2" className="hds-mb-20-24">{title}</Text>
        <StyledHtml>{text}</StyledHtml>
        {buttons &&
            <ButtonList variant="default">
                {buttons.map((button, index) => (
                    <Button
                        className="hds-mt-20-24"
                        asChild
                        variant={index === 0 ? "primary" : "secondary"}
                        fullWidth={false}
                        size='large'
                    >
                        <a href={button.url} target={button.buttonTarget}>{button.linkText}</a>
                    </Button>
                ))}

            </ButtonList>
        }
    </Box>
)
